import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { TypeCustomerService } from '../../services/type-customer.service';

@Component({
  selector: 'app-create-type-customer',
  templateUrl: './create-type-customer.component.html',
  styleUrls: ['./create-type-customer.component.css']
})
export class CreateTypeCustomerComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];

constructor(
  protected _service: TypeCustomerService,
  protected _injector: Injector,
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    customerCode: new UntypedFormControl('', [Validators.required]),
    customerName: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl(''),
    notes: new UntypedFormControl(''),
  });
}

ngOnInit() {
}

onShowPopup() {
  this.validationSummary.resetErrorMessages();
  this.resetForm();
  this.onReset();

  this.itemDetail.id = 0;
  this.itemDetail.status = 1;
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }
  
  this.onInsert();
}

onInsert() {
  this._service.create(this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showInsertDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showInsertDataFailed();
      this.submitting = false;
    }
  );
}
}
